import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { FullScreenSpin } from "_c/preloader";
import { steps as baseSteps } from "./config";
import { useCurrentStepComponent } from "./hooks/useCurrentStepComponent";
import { MASTER_CLIENTS_NS } from "@/i18n/ns";
import isempty from "lodash/isEmpty";

const MasterUserInitialSetup = ({ onClose, skipSteps }) => {
  const steps = useMemo(() => {
    if (isempty(skipSteps)) return baseSteps;
    return baseSteps.filter((step) => !skipSteps.includes(step));
  }, [skipSteps]);
  const [step, setStep] = useState(steps[0]);
  useEffect(() => {
    if (isempty(steps)) onClose();
  }, [steps, onClose]);
  const nextStep = useMemo(() => {
    const idx = steps.findIndex((s) => s === step);
    if (idx === -1) return null;
    return steps[idx + 1];
  }, [step]);
  const goNext = () => {
    if (nextStep) {
      setStep(nextStep);
    } else {
      onClose();
    }
  };
  const { t, ready } = useTranslation(["common", "errors", MASTER_CLIENTS_NS], {
    useSuspense: false,
  });
  const StepComponent = useCurrentStepComponent(step);
  if (!ready) return <FullScreenSpin isLight />;
  return <StepComponent goNext={goNext} t={t} />;
};

export default MasterUserInitialSetup;
